<template>
  <div class="v-text-input" :class="cssClasses">
    <label class="input-label" :for="id">{{label}}</label>
    <input
      type="text"
      name="test"
      :placeholder="placeholder"
      class="input-field"
      :id="id"
      :value="value"
      @blur="isFocused = false"
      @focus="isFocused = true"
      @input="$emit('input', $event.target.value)"
      :disabled="disabled"
    />
  </div>
</template>

<script>
export default {
  name: "v-text-input",
  props: {
    label: { type: String },
    disabled: { type: Boolean, default: false },
    placeholder: { String },
    value: { type: String },
    id: { type: String, default: "" }
  },
  data() {
    return {
      selected: null,
      selectElement: null,
      isFocused: false
    };
  },
  computed: {
    cssClasses() {
      let classes = [];
      if (this.isFocused) classes.push("is-focused");
      if (this.value) classes.push("has-value");
      return classes;
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../design/variables.scss";

.v-text-input {
  position: relative;
  width: 100%;
  background-color: transparent;
  font-size: 1rem;
  line-height: 1.5;
  font-family: inherit;
  outline: none;

  .input-label {
    position: absolute;
    left: 16px;
    top: 0px;
    transition: all ease-in-out 60ms;
    transform: translateY(16px);
    font-size: 1rem;
    color: map-deep-get($colors, "foreground", "secondary");
    pointer-events: none;
  }

  &.is-focused {
    .input-field {
      &::placeholder {
        color: map-deep-get($colors, "foreground", "secondary");
      }
      &:-ms-input-placeholder {
        color: map-deep-get($colors, "foreground", "secondary");
      }
      &::-ms-input-placeholder {
        color: map-deep-get($colors, "foreground", "secondary");
      }
    }
  }

  &.is-focused,
  &.has-value {
    .input-label {
      font-size: 0.7rem;
      transform: translateY(6px);
      top: 0px;
    }
    .input-field {
      padding-top: 25px;
      padding-bottom: 13px;
    }
  }

  .input-field {
    outline: none;
    transition: border ease-in-out 200ms;
    border: 1px solid map-deep-get($colors, "ornament", "border");
    border-radius: 4px;
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 19px;
    padding-bottom: 19px;
    width: 100%;
    font-size: 1rem;
    // IE11
    &:-ms-input-placeholder {
      color: transparent;
    }
    // Edge
    &::-ms-input-placeholder {
      color: transparent;
    }
    &::placeholder {
      color: transparent;
    }
    &[disabled] {
      cursor: not-allowed;
      border-color: map-deep-get($colors, "ornament", "divider");
      background-color: map-deep-get($colors, "background", "secondary");
      &::placeholder {
        color: map-deep-get($colors, "ornament", "border");
      }
    }
    &:focus {
      border-color: map-deep-get($colors, "foreground", "action");
      outline: none;
    }
  }
}
</style>